import { ISubmission, clone, EModalType } from '../../helpers/';
import { DEFAULT_SUBMISSION } from '../../constants';
import types from '../types';

export interface ISubmissionConfigState {
    submission: ISubmission;
    componentId: string;
}

export const initialState: ISubmissionConfigState = {
    submission: clone(DEFAULT_SUBMISSION),
    componentId: null
};

const submissionConfigReducer = function(state:ISubmissionConfigState = initialState, action): ISubmissionConfigState {

	let stateClone:ISubmissionConfigState = clone(state);

	switch(action.type) {

		case types.UPDATE_SUBMISSION_DIALOG:
			stateClone = updateSubmissionDialog(stateClone, action.submission);
			break;

        case types.TOGGLE_DIALOG:
            stateClone = toggleDialog(stateClone, action.openModal, action.componentId, action.submission);
            break;

	}

	return stateClone;

};

let updateSubmissionDialog = (state: ISubmissionConfigState, submission: ISubmission) => {

	state.submission = submission;
	return state;

};

let toggleDialog = (state:ISubmissionConfigState, openModal:EModalType, componentId: string, submission: ISubmission) => {

    if(openModal === EModalType.SubmissionConfig) {

        state.submission = submission;
        state.componentId = componentId;

    }	

	return state;

};

export default submissionConfigReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/submission-config.ts